<template>
  <div>
    <page-header :order="order"></page-header>
    <div class="container">
      <main class="main">
        <div class="inquiredNotCompleted" v-if="isCurrentUser && !isInquired && isAfterUserRegistration">
          <div class="inquiredNotCompleted__label">
            この求人への応募は完了しておりません。
          </div>
          <div class="info__btn">
            <a class="btn btn--large btn--gold" href="#contact">
              <span class="btn__text">
                この求人に応募する
              </span>
            </a>
          </div>
        </div>
        <div class="dataDisplay">
          <div class="dataDisplay__header">
            <div class="cassette cassette--onlyHeader">
              <div class="cassette__header" style="display: block;">
                <span class="cassette__inquiredLabel" v-if="isInquired">応募済み</span>
                <div class="cassette__img" style="float: left;">
                  <img :src="assetsImagePath.m3c_icon" alt="m3c-icon"/>
                </div>
                <div class="cassette__main" style="display: block;">
                  <div class="cassette__top">
                    <span class="label">{{ order.hospital_workplace_type }}</span>
                  </div>
                  <span class="displayHospitalTitle">施設名</span>
                  <span class="displayHospitalName">{{ order.hospital_name }}</span>
                  <span style="margin-left: 10px; font-size: 0.9em;">求人ID: {{ order.order_number }}</span>
                  <h2 class="cassette__heading">{{ order.catch_copy }}</h2>
                </div>
                <div class="info__btn">
                  <a class="btn btn--large btn--gold" href="#contact">
                    <span class="btn__text">
                      この求人に問い合わせる
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="info__contents">
            <information-table
              :order="order"
              :isDisplayedMap="isDisplayedMap"
              :assetsImagePath="assetsImagePath">
            </information-table>
            <div id="notice_inquiry">
              <p>
                ※記載された条件以外は担当コンサルタントから別途明示いたします。
              </p>
            </div>
          </div>

            <div class="detailDisplay__contents">
              <section id="contact" class="contact">
                <div id="fix-contact"></div>
                <h4 class="contact__heading">この求人についてのお問い合わせ(無料)</h4>
                <div class="contact__contents">

                  <div class="form">
                    <form @submit.prevent="onSubmit">
                      <div class="form__header">

                        <ul class="styledInput" v-if="errorFlagFromApi">
                          <b class="errorTitle">予期せぬエラーが発生しました。</b>
                          <b class="errorTitle" v-if="notLoginFlag">ログインしてください</b>

                          <div v-if="notLoginFlag"
                                style="border: 1px solid #ccc; margin-top: 10px; padding-bottom: 20px;">
                            <p style="text-align: center; margin-top: 20px; font-weight: bold;">
                              病院への直接応募にはログインが必要です</p>
                            <div class="info__btn">
                              <a class="btn btn--large btn--navy" href="/user/sign_in">
                                <span class="btn__text">
                                  ログイン画面へ
                                </span>
                              </a>
                            </div>
                            <div class="info__btn">
                              <a class="btn btn--large btn--navy" href="/users/new">
                                <span class="btn__text">
                                  会員IDをお持ちでない方
                                </span>
                              </a>
                            </div>
                          </div>
                          <li class="errorComment" v-if="!publishedOrder">求人票が終了しています。</li>
                          <li class="errorComment" v-show="!validation.name_required">お名前は必須です</li>
                          <li class="errorComment" v-show="!validation.name_long">お名前は80文字以内で入力してください</li>
                          <li class="errorComment" v-show="!validation.phone_required">電話番号は必須です</li>
                          <li class="errorComment" v-show="!validation.phone_wrong">電話番号が正しくありません</li>
                          <li class="errorComment" v-show="!validation.email_required">メールアドレスは必須です</li>
                          <li class="errorComment" v-show="!validation.email_long">メールアドレスは80文字以内で入力してください</li>
                          <li class="errorComment" v-show="!validation.email_wrong">メールアドレスが正しくありません</li>
                          <li class="errorComment" v-show="!validation.message_long">お問い合わせ内容は2000文字以内で入力してください</li>
                          <li class="errorComment" v-show="!validation.birthyear_inclusion">出生年が不正な値です</li>
                          <li class="errorComment" v-show="!validation.experience_year_inclusion">医療機関経験年数が不正な値です</li>
                        </ul>

                        <div class="form__contents form__contents--gutter">
                          <table class="form__table form__table--input">
                            <tbody>
                            <tr v-bind:class="['is-required']">
                              <th>お名前</th>
                              <td class="styledInput styledInput--simple">
                                <div>
                                  <vue-input name="name" type="text" placeholder="例：山田　太郎" v-model="form.name"
                                             v-bind:class_name="[ isNameValid? 'styledInput__errorInput' : 'styledInput__input' ]"
                                             v-on:blur="handleNameBlur();checkValue();"></vue-input>
                                  <span v-if="isNameValid">
                                    <p class="errorComment" v-show="!validation.name_required">お名前は必須です</p>
                                    <p class="errorComment"
                                       v-show="!validation.name_long">お名前は80文字以内で入力してください</p>
                                  </span>
                                </div>
                              </td>
                            </tr>

                            <tr v-bind:class="['is-required']">
                              <th>電話番号</th>
                              <td class="styledInput styledInput--simple">
                                <div>
                                  <vue-input name="phone" type="tel" placeholder="例：09012345678" v-model="form.phone"
                                             v-bind:class_name="[ isPhoneValid? 'styledInput__errorInput' : 'styledInput__input' ]"
                                             v-on:blur="handlePhoneBlur();checkValue();"></vue-input>
                                  <span v-if="isPhoneValid">
                                    <p class="errorComment" v-show="!validation.phone_required">電話番号は必須です</p>
                                    <p class="errorComment" v-show="!validation.phone_wrong">電話番号が正しくありません</p>
                                  </span>
                                </div>
                              </td>
                            </tr>

                            <tr v-bind:class="['is-required']">
                              <th>メールアドレス</th>
                              <td class="styledInput styledInput--simple">
                                <div>
                                  <vue-input name="email" type="email" placeholder="例：taro_yamada@m3career.com"
                                             v-model="form.email"
                                             v-bind:class_name="[ isEmailValid? 'styledInput__errorInput' : 'styledInput__input' ]"
                                             v-on:blur="handleEmailBlur();checkValue();"></vue-input>
                                  <span v-if="isEmailValid">
                                    <p class="errorComment" v-show="!validation.email_required">メールアドレスは必須です</p>
                                    <p class="errorComment"
                                       v-show="!validation.email_long">メールアドレスは80文字以内で入力してください</p>
                                    <p class="errorComment" v-show="!validation.email_wrong">メールアドレスが正しくありません</p>
                                  </span>
                                </div>
                              </td>
                            </tr>

                            <tr class="is-required">
                                <th>出生年</th>
                                <td>
                                  <vue-select name="select" v-model="form.birthyear"
                                              :options="birthyearSelector.birthyear_options"
                                              v-bind:class_name="[ isBirthYearValid? 'styledSelect__errorSelect' : 'styledSelect__inquirySelect' ]"
                                              v-on:blur="handleBirthYearBlur();checkValue();">
                                    <template #default="slotProps">
                                      <option v-for="(option, key) in slotProps.options"
                                              :key="option.key"
                                              :value="option.value"
                                              :selected="form.birthyear === option.value"
                                      >{{ option.key }}
                                      </option>
                                    </template>
                                  </vue-select>
                                  <span v-if="isBirthYearValid">
                                  <p class="errorComment" v-show="!validation.birthyear_required">出生年は必須です</p>
                                  </span>
                                </td>
                              </tr>
                              <tr class="is-required">
                                <th>医療機関経験年数</th>
                                <td>
                                  <vue-select name="select" v-model="form.experience_year"
                                              :options="experienceYearSelector.experience_year_options"
                                              v-bind:class_name="[ isExperienceYearValid? 'styledSelect__errorSelect' : 'styledSelect__inquirySelect' ]"
                                              v-on:blur="handleExperienceYearBlur();checkValue();">
                                    <template #default="slotProps">
                                      <option v-for="(option, key) in slotProps.options"
                                              :key="option.key"
                                              :value="option.value"
                                              :selected="form.experience_year === option.value"
                                      >{{ option.key }}
                                      </option>
                                    </template>
                                  </vue-select>
                                  <span v-if="isExperienceYearValid">
                                  <p class="errorComment"
                                    v-show="!validation.experience_year_required">医療機関経験年数は必須です</p>
                                </span>
                                </td>
                              </tr>
                              <tr class="is-optional">
                                <th>お問い合わせ内容</th>
                                <td class="styledInput styledInput--simple">
                                  <vue-input name="message" type="text" placeholder="コメントを入力する" v-model="form.message"
                                             v-bind:class_name="[ isMessageValid? 'styledInput__errorInput' : 'styledInput__input' ]"
                                             v-on:blur="handleMessageBlur();checkValue();"></vue-input>
                                  <span v-if="isMessageValid">
                                  <p class="errorComment"
                                      v-show="!validation.message_long">お問い合わせ内容は2000文字以内で入力してください</p>
                                </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="form__footer">
                          <p class="errorComment" v-show="invalidAuthenticityToken"
                            style="text-align: center; font-weight: bold;">
                            正しく処理が完了できませんでした。<br/>お手数ですがページをリロード（再読み込み）して<br/>再度お問い合わせください
                          </p>
                          <ul class="form__notice form__notice--gutter">
                            <li class="center-on-sp agreement-text">
                              <a
                                href="https://jimushoku.m3career.com/terms" 
                                target="_blank" style="color: blue; text-decoration: underline;">
                                利用規約
                              </a>、
                              <a 
                                href="https://www.m3career.com/privacy/#policy" 
                                target="_blank" 
                                style="color: blue; text-decoration: underline;">
                                個人情報保護方針
                              </a>
                              に同意し、
                            </li>
                          </ul>
                          <div class="form__btn">
                            <button v-if="isValid && !onClicked" class="btn btn--large btn--gold"
                                    type="submit">
                              <span class="btn__text">この求人に問い合わせる</span>
                            </button>
                            <div v-if="!isValid && !onClicked" class="btn btn--large btn--gold" @click="handleInvalidSubmit">
                              <span class="btn__text">この求人に問い合わせる</span>
                            </div>
                            <div v-if="onClicked" class="btn btn--large btn--gray">
                              <span class="btn__text">登録中 <div id="loading"></div></span>
                            </div>
                          </div>
                          <div class="disclaimer-text">
                            <span>
                              ※ご提供いただいた回答情報は、職業紹介で応募を希望する求人先に応募情報を提供する際や、
                              求人情報に関するメールを配信するため等に使用します。
                            </span>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </section>
            </div>
        </div>
        <section class="flow">
          <h2 class="flow__heading">
            転職支援サービスの流れ
          </h2>
          <div class="flow__contents">
            <ul class="flow__list">
              <li class="flow__item">
                <p class="flow__number">STEP 1</p>
                <div class="flow__img">
                  <img :src="assetsImagePath.first_flow_path_pc" class="is-pc" alt="STEP 1">
                  <img :src="assetsImagePath.first_flow_path_sp" class="is-sp" alt="STEP 1">
                </div>
                <p class="flow__text">
                  このサイトから<br class="is-pc">求人内容について<br class="is-pc">問い合わせる
                </p>
              </li>
              <li class="flow__item">
                <p class="flow__number">STEP 2</p>
                <div>
                  <div class="flow__img">
                    <img :src="assetsImagePath.second_flow_path_pc" class="is-pc" alt="STEP2">
                    <img :src="assetsImagePath.second_flow_path_sp" class="is-sp" alt="STEP2">
                  </div>
                  <p class="flow__text">
                    コンサルタントが<br class="is-pc">希望条件をヒアリング<br>
                    求人のご案内
                  </p>
                </div>
              </li>
              <li class="flow__item">
                <p class="flow__number">STEP 3</p>
                <div class="flow__img">
                  <img :src="assetsImagePath.third_flow_path_pc" class="is-pc" alt="STEP3">
                  <img :src="assetsImagePath.third_flow_path_sp" class="is-sp" alt="STEP3">
                </div>
                <p class="flow__text">
                  書類選考・面接
                </p>
              </li>
              <li class="flow__item">
                <p class="flow__number">STEP 4</p>
                <div class="flow__img">
                  <img :src="assetsImagePath.forth_flow_path_pc" class="is-pc" alt="STEP4">
                  <img :src="assetsImagePath.forth_flow_path_sp" class="is-sp" alt="STEP4">
                </div>
                <p class="flow__text">
                  医療機関からの<br class="is-pc">内定の後、勤務開始
                </p>
              </li>
            </ul>
          </div>
        </section>
      </main>
    </div>
    <vue-google-for-jobs :googleForJobsInfo="googleForJobsInfo"/>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import _ from 'lodash'
import axios from 'axios'

export default {
  name: 'InquiryNew',
  props: [
    'value',
    'desiredConditionInfo',
    'orderInfo',
    'googleForJobsArgs',
    'birthYearInfo',
    'experienceYearInfo',
    'prefectureInfo',
    'startTimeInfo',
    'workStyleInfo',
    'salaryInfo',
    'imagePathInfo',
    'userStatusInfo',
    'hospitalStyleInfo',
    'jobKindInfo',
    'desiredExperienceYearInfo',
    'isInquired',
    'isResumeRegistered',
    'isAfterUserRegistration',
    'phoneFormat',
  ],
  data: function () {
    return {
      // 希望条件
      desiredCondition: _.cloneDeep(this.desiredConditionInfo),
      // 求人情報
      order: _.cloneDeep(this.orderInfo),
      // Google for jobsの情報
      googleForJobsInfo: _.cloneDeep(this.googleForJobsArgs),
      // 問い合わせの初期情報
      form: _.cloneDeep(this.value),
      // 出生年の選択一覧
      birthyearSelector: _.cloneDeep(this.birthYearInfo),
      experienceYearSelector: _.cloneDeep(this.experienceYearInfo),
      prefectureSelector: _.cloneDeep(this.prefectureInfo),
      startTimeSelector: _.cloneDeep(this.startTimeInfo),
      workStyleSelector: _.cloneDeep(this.workStyleInfo),
      salarySelector: _.cloneDeep(this.salaryInfo),
      hospitalStyleSelector: _.cloneDeep(this.hospitalStyleInfo),
      jobKindSelector: _.cloneDeep(this.jobKindInfo),
      desiredExperienceYearSelector: _.cloneDeep(this.desiredExperienceYearInfo),
      assetsImagePath: _.cloneDeep(this.imagePathInfo),
      isCurrentUser: _.cloneDeep(this.userStatusInfo),
      phoneFormatData: _.cloneDeep(this.phoneFormat),
      // 1度でもその項目を選択しているかどうか
      nameTouched: false,
      phoneTouched: false,
      emailTouched: false,
      birthYearTouched: false,
      experienceYearTouched: false,
      messageTouched: false,
      workStyleTouched: false,
      startTimeTouched: false,
      salaryTouched: false,
      hospitalStyleTouched: [false],
      hospitalExperienceYearTouched: [false],
      jobKindTouched: [false],
      jobExperienceYearTouched: [false],
      placePrefectureTouched: false,
      placeCityTouched: [false],
      // Api経由でvalidationを取得
      errorFlagFromApi: false,
      publishedOrder: true,
      notLoginFlag: false,
      onClicked: false,
      invalidAuthenticityToken: false,
      containsValueChecked: false,
    }
  },

  computed: {
    ...mapGetters('inquiry', {'getValue': 'getValue'}),
    // 1度でもその項目を選択しているかどうか
    isNameTouched: function () {
      return this.nameTouched;
    },
    isPhoneTouched: function () {
      return this.phoneTouched;
    },
    isEmailTouched: function () {
      return this.emailTouched;
    },
    isBirthYearTouched: function () {
      return this.birthYearTouched;
    },
    isExperienceYearTouched: function () {
      return this.experienceYearTouched
    },
    isMessageTouched: function () {
      return this.messageTouched;
    },
    isWorkStyleTouched: function () {
      return this.workStyleTouched;
    },
    isStartTimeTouched: function () {
      return this.startTimeTouched;
    },
    isSalaryTouched: function () {
      return this.salaryTouched;
    },
    isHospitalExperienceYearTouched: function () {
      return (index) => this.hospitalExperienceYearTouched[index];
    },
    isJobExperienceYearTouched: function () {
      return (index) => this.jobExperienceYearTouched[index];
    },
    isPlacePrefectureTouched: function () {
      return this.placePrefectureTouched;
    },
    isPlaceCityTouched: function () {
      return (index) => this.placeCityTouched[index];
    },
    validation: function () {
      const form = this.form
      const desiredCondition = this.desiredCondition
      return {
        name_required: (!!form.name),
        name_long: (!!form.name && form.name.length <= 80),
        // メールアドレス
        email_required: (!!form.email),
        email_long: (!!form.email && form.email.length <= 80),
        email_wrong: (!!form.email && this.validEmail(form.email)),
        // 電話番号
        phone_required: (!!form.phone),
        phone_wrong: (!!form.phone && this.validPhone(form.phone)),
        // 出生年
        birthyear_required: (!!form.birthyear),
        birthyear_inclusion: true,
        // 医療機関経験年数(0は許容する）
        experience_year_required: (form.experience_year !== null && form.experience_year !== undefined),
        experience_year_inclusion: true,
        // メッセージ
        message_long: (!!form.message ? form.message.length <= 2000 : true),
      }
    },
    // 全ての項目にエラーがないか
    // 1度でもfalseが返却された場合validationあり
    isValid: function () {
      const validation = this.validation
      return Object
          .keys(validation)
          .every(function (key) {
            return validation[key]
          })
    },
    // それぞれの項目にvalidationがないか
    isNameValid: function () {
      return (!this.validation.name_long || !this.validation.name_required) && this.isNameTouched
    },
    isEmailValid: function () {
      return (!this.validation.email_required || !this.validation.email_long || !this.validation.email_wrong) && this.isEmailTouched
    },
    isPhoneValid: function () {
      return (!this.validation.phone_required || !this.validation.phone_wrong) && this.isPhoneTouched
    },
    isBirthYearValid: function () {
      return !this.validation.birthyear_required && this.isBirthYearTouched
    },
    isExperienceYearValid: function () {
      return !this.validation.experience_year_required && this.isExperienceYearTouched
    },
    isMessageValid: function () {
      return !this.validation.message_long && this.isMessageTouched
    },
    isHospitalStyleValid: function () {
      return (index) => (!this.hospital_style_required(index) || !this.hospital_style_duplicated(index)) && this.isHospitalStyleTouched(index)
    },
    isHospitalStyleTouched: function () {
      return (index) => this.hospitalStyleTouched[index];
    },
    isHospitalExperienceYearValid: function () {
      return (index) => !this.hospital_experience_year_required(index) && this.isHospitalExperienceYearTouched(index)
    },
    isJobKindValid: function () {
      return (index) => !this.job_kind_required(index) && this.isJobKindTouched(index)
    },
    isJobKindTouched: function () {
      return (index) => this.jobKindTouched[index];
    },
    isPlacePrefectureValid: function () {
      return !this.place_prefecture_required && this.isPlacePrefectureTouched
    },
    isPlaceCityValid: function () {
      return (index) => (!this.place_city_required(index) || !this.place_city_long(index)) && this.isPlaceCityTouched(index)
    },
    isJobExperienceYearValid: function () {
      return (index) => !this.job_experience_year_required(index) && this.isJobExperienceYearTouched(index)
    },
    isDisplayedMap: function () {
      return this.order.hospital_longitude_latitude !== null && this.order.publish_hospital_name
    },
    hospital_style_required: function () {
      return (index) => this.desiredCondition['desired_condition_hospitals'][index] !== undefined &&
          this.desiredCondition['desired_condition_hospitals'][index].style !== null &&
          this.desiredCondition['desired_condition_hospitals'][index].style !== undefined
    },
    hospital_style_duplicated: function () {

      return (index) => {
        let selectedStyles = []
        const value = this.desiredCondition['desired_condition_hospitals'][index].style
        this.desiredCondition['desired_condition_hospitals'].forEach((hospital, hospital_index) => {
          if (hospital_index !== index) {
            selectedStyles.push(hospital.style)
          }
        })
        return !selectedStyles.some(style => style === value && value !== null)
      }
    },
    hospital_experience_year_required: function () {
      return (index) => this.desiredCondition['desired_condition_hospitals'][index] !== undefined &&
          this.desiredCondition['desired_condition_hospitals'][index].experience_year !== null &&
          this.desiredCondition['desired_condition_hospitals'][index].experience_year !== undefined
    },
    job_kind_required: function () {
      return (index) => this.desiredCondition['desired_condition_jobs'][index] !== undefined &&
          this.desiredCondition['desired_condition_jobs'][index].kind !== null &&
          this.desiredCondition['desired_condition_jobs'][index].kind !== undefined
    },
    place_city_required: function () {
      return (index) => this.desiredCondition['desired_condition_places'][index] !== undefined &&
          this.desiredCondition['desired_condition_places'][index].city !== null &&
          this.desiredCondition['desired_condition_places'][index].city !== undefined
    },
    place_city_long: function () {
      return (index) => this.desiredCondition['desired_condition_places'][index].city === null ||
          this.desiredCondition['desired_condition_places'][index].city.length <= 50 // TODO 文字数
    },
    job_experience_year_required: function () {
      return (index) => this.desiredCondition['desired_condition_jobs'][index] !== undefined &&
          this.desiredCondition['desired_condition_jobs'][index].experience_year !== null &&
          this.desiredCondition['desired_condition_jobs'][index].experience_year !== undefined
    },
    place_prefecture_required: function () {
      return this.desiredCondition['desired_condition_places'][0].prefecture !== null &&
          this.desiredCondition['desired_condition_places'][0].prefecture !== undefined &&
          this.desiredCondition['desired_condition_places'][0].prefecture !== ''
    }
  },

  created: function () {
    // 離脱アラート
    // IOSでは動作しないので今後要検討
    window.onbeforeunload = (e) => {
      if (!this.$store.state.onClickSubmit && this.containsValueChecked) {
        // 一部ブラウザでは固定のメッセージ
        e.returnValue = '登録が完了していません。このまま移動しますか？'
      }
    }
  },

  mounted: function () {
    if (this.getValue !== undefined) {
      if (Object.keys(this.getValue).length > 0) {
        this.form = this.getValue
      }
    }
  },

  watch: {
    // ブラウザの戻るボタンを押した時の挙動
    '$route'(to, from) {
      if (this.$route.name == 'New') {
        this.$store.commit('setNewCount')
      }
    }
  },

  methods: {
    // 確認画面へ
    onSubmit: function (e) {
      this.onClicked = true
      this.invalidAuthenticityToken = false
      axios.post('/api/orders/' + this.order.id + '/inquiries', {
        inquiry: this.form,
        desired_condition: {
          motivation: this.desiredCondition.motivation,
          work_style: this.desiredCondition.work_style,
          start_time: this.desiredCondition.start_time,
          salary: this.desiredCondition.salary,
        },
        desired_condition_hospitals: this.desiredCondition['desired_condition_hospitals'],
        desired_condition_jobs: this.desiredCondition['desired_condition_jobs'],
        desired_condition_places: this.desiredCondition['desired_condition_places']
      }).then((response) => {
        if (response.status == 200) {
          // クリックしたことを記録
          this.$store.commit('setOnClickSubmit')
          // 情報を更新
          this.$store.commit('inquiry/updateInquiryForm', this, this.form)
          // Thanksへリダイレクト
          window.location.assign('/orders/' + this.order.id + '/inquiries/profile')
        } else {
          // 不正にアクセスした場合(想定外)
          this.$store.commit('setNewCount')
          // ボタンクリックをリセットさせる
          this.$store.commit('resetOnClickSubmit')
          this.$router.push({name: 'New', params: {orderId: this.order.id}})
        }
      }).catch((error) => {
        this.onClicked = false
        console.log(error)
        // エラー検知を検討する
        // ボタンクリックをリセットさせる
        this.$store.commit('resetOnClickSubmit')
        this.errorFlagFromApi = true
        if (error.response.status == 422) {
          // Api経由でエラーが帰ってきた場合の挙動(想定外の動き)
          // validationチェックを確認(422はValidationエラーとする)
          if (error.response.data.errors.order !== undefined) {
            this.publishedOrder = false
          }
          if (error.response.data.errors.name !== undefined) {
            this.validation.name_required = !error.response.data.errors.name.includes('blank')
            this.validation.name_long = !error.response.data.errors.name.includes('too_long')
          }
          if (error.response.data.errors.inquiry.email !== undefined) {
            this.validation.email_required = !error.response.data.errors.inquiry.email.includes('blank')
            this.validation.email_long = !error.response.data.errors.inquiry.email.includes('too_long')
            this.validation.email_wrong = !error.response.data.errors.inquiry.email.includes('invalid')
          }
          if (error.response.data.errors.inquiry.phone !== undefined) {
            this.validation.phone_required = !error.response.data.errors.inquiry.phone.includes('blank')
            this.validation.phone_wrong = !error.response.data.errors.inquiry.phone.includes('invalid') || !error.response.data.errors.inquiry.phone.includes('too_short')
          }
          if (error.response.data.errors.inquiry.birthyear !== undefined) {
            this.validation.birthyear_required = !error.response.data.errors.inquiry.birthyear.includes('blank')
            this.validation.birthyear_inclusion = !error.response.data.errors.inquiry.birthyear.includes('inclusion')
          }
          if (error.response.data.errors.inquiry.experience_year !== undefined) {
            this.validation.experience_year_required = !error.response.data.errors.inquiry.experience_year.includes('blank')
            this.validation.experience_year_inclusion = !error.response.data.errors.inquiry.experience_year.includes('inclusion')
          }
          if (error.response.data.errors.inquiry.message !== undefined) {
            this.validation.message_long = !error.response.data.errors.inquiry.message.includes('too_long')
          }
        } else if (error.response.status == 403) {
          this.errorFlagFromApi = true
          if (error.response.data.errors.login === false) {
            this.notLoginFlag = true
          }
        } else {
          if (error.response.data.error_message !== undefined) {
            this.invalidAuthenticityToken = true
          } else {
            // TODO
            // エラー検知を検討する
          }
        }
      })
    },
    // validPhone以外はModel側に準拠
    validEmail: function (email) {
      var re = /^[\w\*!#\$%&'\*\+\-\.\/=\?\^`\{\|}]+@[\w\*!#\$%&'\*\+\-\.\/=\?\^`\{\|}]+\.[a-z]+$/
      return re.test(email)
    },
    validPhone: function (phone) {
      // 電話番号向けのバリデーションを定義する
      return new RegExp(this.phoneFormatData).test(phone)
    },
    handleNameBlur: function () {
      this.nameTouched = true
    },
    handlePhoneBlur: function () {
      this.phoneTouched = true
    },
    handleEmailBlur: function () {
      this.emailTouched = true
    },
    handleBirthYearBlur: function () {
      this.birthYearTouched = true
    },
    handleExperienceYearBlur: function () {
      this.experienceYearTouched = true
    },
    handleMessageBlur: function () {
      this.messageTouched = true
    },
    handleInvalidSubmit: function () {
      this.nameTouched = true
      this.emailTouched = true
      this.phoneTouched = true
      this.birthYearTouched = true
      this.experienceYearTouched = true
      this.checkValue()
    },
    handleWorkStyleBlur: function () {
      this.workStyleTouched = true
    },
    handleStartTimeBlur: function () {
      this.startTimeTouched = true
    },
    handleSalaryBlur: function () {
      this.salaryTouched = true
    },
    handleHospitalExperienceYearBlur: function (index) {
      this.hospitalExperienceYearTouched[index] = true
      this.hospitalExperienceYearTouched.splice() // 強制的に再描画
    },
    handleHospitalStyleBlur: function (index) {
      this.hospitalStyleTouched[index] = true
      this.hospitalStyleTouched.splice() // 強制的に再描画
    },
    handleJobKindBlur: function (index) {
      this.jobKindTouched[index] = true
      this.jobKindTouched.splice() // 強制的に再描画
    },
    handleJobExperienceYearBlur: function (index) {
      this.jobExperienceYearTouched[index] = true
      this.jobExperienceYearTouched.splice() // 強制的に再描画
    },
    handlePlacePrefectureBlur: function () {
      this.placePrefectureTouched = true
    },
    handlePlaceCityBlur: function (index) {
      this.placeCityTouched[index] = true
      this.placeCityTouched.splice() // 強制的に再描画
    },
    checkValue: function () {
      const form = this.form
      const valueList = ['name', 'email', 'phone', 'birthyear', 'experience_year', 'message']
      let resultList = []
      $.each(valueList, function (key, value) {
        if (form[value] === null || form[value] === '') {
          resultList.push(value)
        }
      })
      if (resultList.length === 5) {
        // 何も入力されていない
        this.containsValueChecked = false;
      } else {
        // 何か入力されている
        this.containsValueChecked = true;
      }
    },
    addDesiredHospital: function () {
      let newHospital = Object.assign({}, JSON.parse(JSON.stringify(this.desiredCondition['desired_condition_hospitals'][0])))
      newHospital.style = null;
      newHospital.experience_year = null;
      this.desiredCondition['desired_condition_hospitals'].push(newHospital)
      this.hospitalStyleTouched.push(false)
      this.hospitalExperienceYearTouched.push(false)

    },
    removeDesiredHospital: function (index) {
      this.desiredCondition['desired_condition_hospitals'].splice(index, 1)
      this.hospitalStyleTouched.splice(index, 1)
      this.hospitalExperienceYearTouched.splice(index, 1)
    },
    addDesiredJob: function () {
      let newJob = Object.assign({}, JSON.parse(JSON.stringify(this.desiredCondition['desired_condition_jobs'][0])))
      newJob.kind = null;
      newJob.experience_year = null;
      this.desiredCondition['desired_condition_jobs'].push(newJob)
      this.jobKindTouched.push(false)
      this.jobExperienceYearTouched.push(false)
    },
    removeDesiredJob: function (index) {
      this.desiredCondition['desired_condition_jobs'].splice(index, 1)
      this.jobKindTouched.splice(index, 1)
      this.jobExperienceYearTouched.splice(index, 1)
    },
    addDesiredPlace: function () {
      let newPlace = Object.assign({}, JSON.parse(JSON.stringify(this.desiredCondition['desired_condition_places'][0])))
      let oldPlace = Object.assign({}, JSON.parse(JSON.stringify(this.desiredCondition['desired_condition_places'][0])))
      newPlace.prefecture = oldPlace.prefecture
      newPlace.city = null;
      this.desiredCondition['desired_condition_places'].push(newPlace)
      this.placeCityTouched.push(false)
    },
    removeDesiredPlace: function (index) {
      this.desiredCondition['desired_condition_places'].splice(index, 1)
      this.placeCityTouched.splice(index, 1)
    },
    changePrefecture: function (value) {
      this.desiredCondition['desired_condition_places'].forEach(place => {
        place.prefecture = value
        place.city = null
      })
    },
  }
}
</script>
